<template>
  <v-container fluid>
    <v-col v-for="(data,index) in dataAd" :key="index" class="mb-9">
      <v-row>
        <v-col class="pa-0  pr-3" cols="1" align="end">Адрес:</v-col>
        <v-col class="pa-0">{{data.adres}}</v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0  pr-3" cols="1" align="end">Телефон:</v-col>
        <v-col class="pa-0">{{data.nomberphone}}</v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0 pr-3" cols="1" align="end">Эл. почта:</v-col>
        <v-col class="pa-0">{{data.website}}</v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    dataAd: [],
  }),
  created() {
    this.dataAd = this.$ls.get("dataAd");
  },
};
</script>